
import './Landing.css';
import Slider from '../Article/Slider';
import Hero from './Hero';
import Articles from '../Article/Articles';
import Contact from './Contact';
import GetApp from './GetApp';
import { Services } from '../Service/Services';
import OnCall from '../Shared/ActionControl';


function Landing({lang, connected, service}) {
  return (
    <div className="App">
      <Slider service={service} lang={lang} />
      <Services service={service} lang={lang} />
      <Articles service={service} lang={lang} />
      <Contact service={service} lang={lang} />
      <GetApp service={service} lang={lang} connected={connected} />
      <OnCall connected={connected} />
    </div>
  );
}

export default Landing;

